import React, { useState } from "react";
import { Input, Select } from "antd";
import countryList from "react-select-country-list";
import IndustryList from "./industryList";
import { CloseOutlined } from "@ant-design/icons";

const { Option } = Select;

const CountryDropdown = () => {
  const options = countryList().getData();

  return (
    <Select
      showSearch
      placeholder="-Select-"
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      style={{ width: "100%", height: "55px", borderRadius: "0px" }}>
      {options.map((country, index) => (
        <Option key={index} value={country.value}>
          {country.label}
        </Option>
      ))}
    </Select>
  );
};

const ContactUsForm = ({ showForm, setShowForm }) => {
  // const [showForm, setshowForm] = useState(true);

  const toggleFormVisibility = () => {
    setShowForm(!showForm);
  };

  return (
    <div
      style={{
        display: showForm ? "flex" : "none",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#F1F2F4",
        padding: "30px 10px",
      }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: "1rem",
        }}>
        <CloseOutlined
          style={{ fontSize: "24px", cursor: "pointer" }}
          onClick={toggleFormVisibility}
        />
      </div>
      <h2
        style={{
          fontSize: "4rem",
          fontWeight: 500,
          color: "#5db014",
          marginBottom: "1rem",
          fontWeight: "300",
        }}>
        CONTACT US
      </h2>
      <div style={{ width: "100%", maxWidth: "600px" }}>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *First name
          </p>
          <Input style={{ borderRadius: "0", padding: "15px" }} />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Last name
          </p>
          <Input style={{ borderRadius: "0", padding: "15px" }} />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Email
          </p>
          <Input style={{ borderRadius: "0", padding: "15px" }} />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Telephone number
          </p>
          <Input style={{ borderRadius: "0", padding: "15px" }} />
        </div>
        <div
          style={{
            marginBottom: "1rem",
            borderRadius: "0px",
            color: "#021d49",
          }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Contact preference
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              color: "#021d49",
            }}>
            <label style={{ marginBottom: "0.5rem", color: "#021d49" }}>
              <input type="radio" name="contact" value="email" />
              Email
            </label>
            <label>
              <input type="radio" name="contact" value="telephone" />
              Telephone
            </label>
          </div>
        </div>
        <div
          style={{
            marginBottom: "1rem",
            borderRadius: "0px",
            color: "#021d49",
          }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Your industry
          </p>
          <IndustryList />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Company name
          </p>
          <Input style={{ borderRadius: "0", padding: "15px" }} />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Address line 1
          </p>
          <Input style={{ borderRadius: "0", padding: "15px" }} />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Address line 2
          </p>
          <Input style={{ borderRadius: "0", padding: "15px" }} />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Zip / Postal Code
          </p>
          <Input style={{ borderRadius: "0", padding: "15px" }} />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *City / Town
          </p>
          <Input style={{ borderRadius: "0", padding: "15px" }} />
        </div>
        <div
          style={{
            marginBottom: "1rem",
            borderRadius: "0px",
            color: "#021d49",
          }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Country
          </p>
          <CountryDropdown />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "2.2rem", fontWeight: 500, color: "#021d49" }}>
            *Enquiry
          </p>
          <textarea
            style={{
              borderRadius: "0px",
              outline: "0px",
              padding: "15px",
              width: "100%",
              minHeight: "150px",
            }}
            placeholder="Your message"
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "30px",
          }}>
          <label style={{ marginBottom: "1.5rem" }}>
            <input type="checkbox" name="contact" value="email" />
            By completing and submitting this form, you confirm that you agree
            to the processing of your personal data by Mac World Logistic as
            described in the Privacy Policy.
          </label>
          <label>
            <input type="checkbox" name="contact" value="telephone" />
            By ticking this box, you agree to receive marketing communications
            regarding Mac World Logistic products, services and events. You can
            unsubscribe and update your preferences at a later time.
          </label>
        </div>
        <button
          style={{
            width: "100%",
            maxWidth: "600px",
            padding: "20px 20px",
            backgroundColor: "#021D49",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 auto",
            boxSizing: "border-box",
          }}>
          SUBMIT
        </button>
      </div>
    </div>
  );
};

export default ContactUsForm;
